import React, { useState } from 'react';
import { Form, Button, Container } from 'react-bootstrap';
import { MessageGateway, MessageType, SendMessageRequest } from '../gateways/MessageGateway';
import { maindb } from '../firebaseConfig';
import { useGlobal } from '../contexts/GlobalContext';
import { doc, getDoc } from 'firebase/firestore';
import { Utils } from '../common/Utils';

const FeedbackForm: React.FC = () => {
    const [subject, setSubject] = useState('');
    const [rating, setRating] = useState(0);
    const [description, setDescription] = useState('');
    const [sending, setSending] = useState(false);
    const [success, setSuccess] = useState<boolean | null>(null);
    const { user } = useGlobal();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setSending(true);
        setSuccess(null);

        try {
            if (!user) throw new Error('User not authenticated');

            const userRef = doc(maindb, "users", user.uid);
            const userSnap = await getDoc(userRef);

            const fromDetails = userSnap.exists() ? `From: ${userSnap.data().firstName} ${userSnap.data().lastName}\nCell:${Utils.FormatPhoneNumber(userSnap.data().phoneCode, userSnap.data().phoneNumber)}\nEmail: ${user.email}` : `From: ${user.email}`;                                      
            const stars = '★'.repeat(rating) + '☆'.repeat(5 - rating);
            const messageBody = `Rating: ${stars}\n\n${description}\n\n${fromDetails}`;

            const payload: SendMessageRequest = {
                messageType: MessageType.Email,
                toAddress: 'hello@orderq.co.za',
                subject: `Shop Feedback: ${subject}`,
                message: messageBody,
            };

            const idToken = await user.getIdToken();
            const response = await MessageGateway.SendMessage(payload, idToken);
            setSuccess(response.ok);
        } catch (error) {
            console.error('SendMessage failed:', error);
            setSuccess(false);
        } finally {
            setSending(false);
        }
    };

    return (
        <Container className="mt-5">
            <h3>Submit Feedback</h3>
            <Form onSubmit={handleSubmit}>
                <Form.Group controlId="feedbackSubject" className="mb-3">
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter title"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        required
                    />
                </Form.Group>

                <Form.Group controlId="feedbackRating" className="mb-3">
                    <Form.Label>Rating</Form.Label>
                    <div>
                        {[1, 2, 3, 4, 5].map((star) => (
                            <span
                                key={star}
                                style={{
                                    cursor: 'pointer',
                                    fontSize: '1.5rem',
                                    color: star <= rating ? '#ffc107' : '#e4e5e9',
                                }}
                                onClick={() => setRating(star)}
                            >
                                ★
                            </span>
                        ))}
                    </div>
                </Form.Group>

                <Form.Group controlId="feedbackDescription" className="mb-3">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={4}
                        placeholder="Describe your experience..."
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        required
                    />
                </Form.Group>

                <Button variant="primary" type="submit" disabled={sending}>
                    {sending ? 'Sending...' : 'Send Feedback'}
                </Button>

                {success === true && (
                    <p className="text-success mt-3">✅ Feedback sent successfully!</p>
                )}
                {success === false && (
                    <p className="text-danger mt-3">❌ Failed to send feedback. Please try again.</p>
                )}
            </Form>
        </Container>
    );
};

export default FeedbackForm;